import { render, staticRenderFns } from "./FixedButton.vue?vue&type=template&id=de5b35d0&scoped=true"
import script from "./FixedButton.vue?vue&type=script&lang=ts"
export * from "./FixedButton.vue?vue&type=script&lang=ts"
import style0 from "./FixedButton.vue?vue&type=style&index=0&id=de5b35d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5b35d0",
  null
  
)

export default component.exports